<template>
  <b-modal
    ref="modal"
    :title="`${this.$_.capitalize(this.$t('share-to-user'))} ${title}`"
    @ok="okClicked"
    :ok-title="$t('close')"
    ok-only
    size="xl"
  >
    <template v-if="users === null && assignments === null">
      <loader />
    </template>
    <template v-else>
      <p>
        <multiselect
          v-model="form.user"
          :options="getUsersForSharing"
          :searchable="true"
          track-by="id"
          :customLabel="item => item.user.username"
          :placeholder="$t('choose')"
          :selectLabel="$t('select')"
          :selectedLabel="$t('selected')"
          :deselectLabel="$t('deselect')"
        />
      </p>
      <p>
        <b-form-group :label="this.$t('permit')" class="mt-3">
          <b-form-checkbox-group
            id="checkbox-group-1"
            v-model="form.permissions"
            :options="options"
            name="access-control"
          />
        </b-form-group>
      </p>
      <p>
        <b-button
          v-if="form.user"
          @click="assignSelected">
          {{ $t('share') }}
          <b-spinner v-if="loading" small type="grow" />
        </b-button>
      </p>
      <h3 class="my-3">{{ $t('shared-with') }}</h3>
      <template v-if="assignments">
        <b-table
          :items="assignments"
          :fields="tableFields"
          striped
          hover
        >
          <template v-slot:cell(user)="{ item }">
            {{ getUserById(item.user).user.username }}
          </template>
          <template v-slot:cell(read)="{ item }">
            {{ $_.includes(item.permissions, 'r') ? '&check;' : '&nbsp;' }}
          </template>
          <template v-slot:cell(write)="{ item }">
            {{ $_.includes(item.permissions, 'w') ? '&check;' : '&nbsp;' }}
          </template>
          <template v-slot:cell(execute)="{ item }">
            {{ $_.includes(item.permissions, 'x') ? '&check;' : '&nbsp;' }}
          </template>
          <template v-slot:cell(delete)="{ item }">
            <font-awesome-icon
                icon="trash-alt"
                class="cursor-pointer"
                @click="removeAssignment(item.id)"
              />
          </template>
        </b-table>
      </template>
    </template>
  </b-modal>
</template>

<script>
import _ from 'lodash';
import config from '@/config';
import axios from 'axios';
import Loader from '@/components/utils/Loader.vue';
import { mapState } from 'vuex';
import ToasterMixin from '@/mixins/Toaster';

export default {
  name: 'userShareModal',
  mixins: [
    ToasterMixin,
  ],
  components: { Loader },
  props: {
    title: {
      type: String,
      default: '',
      required: false,
    },
    assignmentsGetFunc: {
      type: Function,
      required: true,
    },
    assignmentsDeleteFunc: {
      type: Function,
      required: true,
    },
    assignmentsCreateFunc: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      users: null,
      assignments: null,
      tableFields: [
        {
          key: 'user',
          label: this.$t('user'),
          sortable: true,
        },
        {
          key: 'read',
          label: this.$t('read-perm'),
        },
        {
          key: 'write',
          label: this.$t('write-perm'),
        },
        {
          key: 'execute',
          label: this.$t('execute-perm'),
        },
        {
          key: 'delete',
          label: this.$t('delete'),
        },
      ],
      form: {
        user: null,
        permissions: [],
      },
      loading: false,
      options: [
        { value: 'r', text: this.$t('read-perm') },
        { value: 'w', text: this.$t('write-perm') },
        { value: 'x', text: this.$t('execute-perm') },
      ],
    };
  },
  computed: {
    ...mapState('snapshot', [
      'currentSnapshot',
    ]),
    getUsersForSharing() {
      if (this.users === null) {
        return [];
      }
      let assignments = [];
      if (this.assignments !== null) {
        assignments = this.assignments;
      }
      const assignedUsersIds = assignments.map(a => a.user);
      return this.users.filter(u => !_.includes(assignedUsersIds, u.user.id));
    },
  },
  methods: {
    show() {
      this.loadUsers();
      this.loadAssignments();
      this.initForm();
      this.$refs.modal.show();
    },
    getUserById(id) {
      if (this.users !== null) {
        return this.users.filter(u => u.user.id === id)[0];
      }
      return null;
    },
    loadAssignments() {
      this.assignmentsGetFunc().then((data) => {
        this.assignments = data;
      });
    },
    loadUsers() {
      const url = new URL(
        config.ICOOL.API.USERS_PATH(this.currentSnapshot.id),
        config.ICOOL.BACKEND_HOST,
      ).href;
      axios
        .get(url)
        .then((response) => {
          this.users = response.data;
        });
    },
    assignSelected() {
      this.loading = true;
      this.assignmentsCreateFunc(
        this.form.user.user.id,
        this.form.permissions.sort().join(''),
      ).then(() => {
        this.showToast(this.$t('sharing'), this.$t('set'), 'success');
        this.loadAssignments();
      }).finally(() => {
        this.assignments = null;
        this.initForm();
        this.loading = false;
      });
    },
    removeAssignment(assignmentId) {
      this.assignmentsDeleteFunc(assignmentId).then(() => {
        this.assignments = this.assignments.filter(a => a.id !== assignmentId);
        this.showToast(this.$t('sharing'), this.$t('removed'), 'success');
      });
    },
    initForm() {
      this.form.user = null;
      this.form.permissions = [];
    },
    okClicked() {

    },
  },
  mounted() {
  },
};
</script>

<style scoped>

</style>
